import { Pipe, PipeTransform } from '@angular/core';
import {ReferentialEntity} from '../models/referential-entity';
import {Value} from '../models/value';

@Pipe({
  name: 'valueFromEntity'
})
export class ValueFromEntityPipe implements PipeTransform {

  /**
   * Get the entity value according to the type
   * @param {ReferentialEntity[]} entities
   * @param {Value} type
   * @returns {Value[]}
   */
  transform(entities: ReferentialEntity[], type: Value): Value[] {
    return entities.filter(entity => entity.referentialId === type.id).map(entity => {
      return new Value(entity);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/value-from-entity.pipe.ts